export const LETTER_COUNT = 550;
export const SPECIAL_CHARACTERS = /([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g